<template>
  <div class="repeat_action">
    <div class="content">
      <a-form :form="form">
        <div class="content_top">
          <a-form-item class="content_top_action">
            <!-- 查重功能 -->
            <h3 class="content_title">
              {{ $t('message["95"]') }}：
            </h3>
            <a-switch
              v-decorator="['isrepeat', {initialValue: fromData.isrepeat}]"
              :checked="fromData.isrepeat === 1"
              @change="changeSwitch"
            />
            <span
              class="switch_text"
              v-text="fromData.isrepeat === 1 ? openedTxt : closedTxt"
            />
          </a-form-item>
          <repeat-fields
            :fields="fields"
            @submit="referFields"
          />
          <a-form-item class="content_top_action">
            <!-- 重复信息禁止保存 -->
            <h3 class="content_title">
              {{ $t('message["1618"]') }}：
            </h3>
            <a-switch
              v-decorator="['isrepeatsave', {initialValue: fromData.isrepeatsave}]"
              :checked="fromData.isrepeatsave === 0"
              :disabled="fromData.isrepeat === 0"
              @change="changeSwitchSave"
            />
            <span
              class="switch_text"
              v-text="fromData.isrepeatsave === 0 ? openedTxt : closedTxt"
            />
          </a-form-item>
          <a-form-item class="content_top_action">
            <!-- 查重白名单 -->
            <h3 class="content_title">
              {{ $t('message["1905"]') }}：
            </h3>
            <a-switch
              :checked="fromData.iswhitelist === 1"
              :disabled="fromData.isrepeat === 0 || fromData.isrepeatsave === 1"
              @change="changeSwitchWhite"
            />
            <span
              class="switch_text"
            >{{ fromData.iswhitelist === 1 ? openedTxt : closedTxt }}</span>
            <div class="edit-white-btn">
              <!-- 编辑 -->
              <a-button
                :disabled="fromData.isrepeat === 0 || fromData.isrepeatsave === 1 || fromData.iswhitelist === 0"
                @click="handleEditWhite"
              >
                {{ $t('message["36"]') }}
              </a-button>
            </div>
          </a-form-item>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import RepeatFields from './RepeatFields'

export default {
  components: {
    RepeatFields
  },
  props: {
    fields: {
      type: Array,
      default: () => ({})
    },
    switchData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      fromData: {
        isrepeatsave: 1,
        isrepeat: 0,
        iswhitelist: 0
      }
    }
  },
  computed: {
    isShowWarning () {
      return this.fields.length === 0
    },
    closedTxt () {
      return this.$t('message["1459"]')
    },
    openedTxt () {
      return this.$t('message["1466"]')
    }
  },
  watch: {
    switchData: {
      handler (newVal) {
        const { isrepeatsave, isrepeat, iswhitelist } = newVal
        this.fromData.isrepeatsave = isrepeatsave
        this.fromData.isrepeat = isrepeat
        this.fromData.iswhitelist = iswhitelist
      },
      immediate: true
    }
  },
  methods: {
    changeSwitch (value) {
      if (this.isShowWarning) {
        this.$message.warning(this.$t('message["559"]'))
      } else {
        let data = this.perpareFormValue('isrepeat', value ? 1 : 0)
        this.$emit('switch', data)
      }
    },
    changeSwitchSave (value) {
      let data = this.perpareFormValue('isrepeatsave', value ? 0 : 1)
      this.$emit('change', data, 'isrepeatsave')
    },
    changeSwitchWhite (value) {
      let data = this.perpareFormValue('iswhitelist', value ? 1 : 0)
      this.$emit('change', data, 'iswhitelist')
    },
    perpareFormValue (key, value) {
      let data = this.fromData
      data[key] = value
      return data
    },
    referFields () {
      this.$bus.$emit('fetchRepeatData')
    },
    handleEditWhite () {
      this.$router.push({
        name: 'RepeatWhite'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.repeat_action {
  margin-top: 28px
}
.content {
  .content_top {
    display: flex;
    flex-direction: column;
    .content_title {
      display: inline-block;
      width: 130px;
      font-size:14px;
      margin-right: 24px;
      color:rgba(102,102,102,1);
      text-align: right;
    }
    .content_top_action {
      margin: 8px 0
    }
    .warning_alert {
      width: 500px;
      position: relative;
      left: 90px;
    }
  }
  .switch_text {
    height: 24px;
    font-size: 13px;
    color:rgba(51,51,51,1);
    line-height: 24px;
    margin-left: 8px;
    vertical-align: middle
  }
  .content_main {
    margin-left:  95px;
  }
}
.edit-white-btn {
  margin-top: 20px;
  padding-left: 154px;
}
</style>
<style lang="scss">
.repeat_action {
  .ant-radio + * {
    padding-left: 4px;
    padding-right: 4px
  }
}
</style>
